import React, { FC, useState } from 'react'

import { Button, ButtonVariants } from '@inno-ui/button'
import { LinesFullIcon } from '@inno-ui/icons'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import BackgroundImage from 'shared/assets/backgrounds/clx-circles-sky-bg.webp'
import { PublicFooter } from 'shared/components/PublicFooter'
import { FEATURE_FLAGS } from 'shared/constants/featureFlags'

import styles from './PublicRouteLayout.module.scss'
import { PublicRouteLayoutProps } from './PublicRouteLayout.types'
import { PublicRouteLanguageSelector } from './components'
import clusterixLogoWhite from '/public/clusterix-logo-white.svg'

const AuthActions: FC = () => {
  const { t } = useTranslation('public')

  return (
    <>
      <Link to='/login' className={styles.loginLink}>
        <Button variant={ButtonVariants.Ghost} label={t('navbar.login')} />
      </Link>
      {FEATURE_FLAGS.REGISTER && (
        <Link to='/register' className={styles.loginLink}>
          <Button variant={ButtonVariants.Dark} label={t('navbar.register')} />
        </Link>
      )}
    </>
  )
}

export const PublicRouteLayout: FC<PublicRouteLayoutProps> = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { t } = useTranslation('public')

  return (
    <div
      className={styles.publicRouteLayout}
      data-public-route
      style={{ backgroundImage: `url(${BackgroundImage})` }}
    >
      <header className={styles.header}>
        <a
          href='https://clusterix.io'
          target='_blank'
          rel='noopener noreferrer'
          className={styles.logoLink}
        >
          <img src={clusterixLogoWhite} alt='Clusterix Logo' />
        </a>
        <div className={styles.actions}>
          <div className={styles.desktopActions}>
            <AuthActions />
          </div>

          <button
            type='button'
            className={styles.menuButton}
            aria-label={t('navbar.openMenu', 'Open menu')}
            aria-expanded={isMenuOpen}
            onClick={() => setIsMenuOpen(prev => !prev)}
          >
            <LinesFullIcon aria-hidden='true' />
          </button>

          {isMenuOpen && (
            <div className={styles.mobileMenu}>
              <AuthActions />
            </div>
          )}

          <PublicRouteLanguageSelector />
        </div>
      </header>
      <main>{children}</main>
      <PublicFooter />
    </div>
  )
}
